import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { getGuide, guidePath } from "@/content/guides";
import { IfGuides } from "@/pages/guides/GuidesOnly";

/** "Learn more" links from a feature page to the guides about it. Renders nothing where the guides are off. */
const GuideLearnMore = ({ slugs, className = "" }: { slugs: string[]; className?: string }) => {
  const guides = slugs.map((s) => getGuide(s)).filter((g) => !!g);
  if (!guides.length) return null;
  return (
    <IfGuides>
      <section aria-label="Learn more" className={`py-12 ${className}`} data-testid="guide-learn-more">
        <div className="container mx-auto max-w-4xl px-4">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.1em] text-muted-foreground">Learn more</p>
          <ul className="m-0 grid list-none gap-4 p-0 md:grid-cols-2">
            {guides.map((g) => (
              <li key={g!.slug}>
                <Link
                  to={guidePath(g!.slug)}
                  className="group flex h-full items-start gap-4 rounded-2xl border border-border bg-card p-5 shadow-sm transition-shadow hover:shadow-md"
                >
                  <span className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-hawk-orange/10 text-hawk-orange">
                    <BookOpen size={18} aria-hidden="true" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block font-semibold group-hover:text-hawk-orange">{g!.title}</span>
                    <span className="mt-1 block text-sm text-muted-foreground">{g!.description}</span>
                  </span>
                  <ArrowRight size={18} aria-hidden="true" className="mt-1 flex-none text-hawk-orange" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </IfGuides>
  );
};

export default GuideLearnMore;
